/**
 * Marcadores de "número ilustrativo — sem API ainda", mesmo padrão de
 * `apps/painel/src/components/lumina/Placeholder.tsx` e
 * `apps/storefront/components/account/Placeholder.tsx`. O protótipo "Super Admin" (Google
 * Stitch) descreve uma escala e uma postura de segurança/compliance fictícias (GMV de
 * dezenas de milhões, milhares de lojas, PCI-DSS, SOC2, WAF, HSM) que a Storeo não tem hoje —
 * cada afirmação assim entra marcada, pra não ser lida como fato sobre a infraestrutura real.
 */

export function PlaceholderTag({ label = 'exemplo' }: { label?: string }) {
  return (
    <span
      title="Número ilustrativo — sem API real, não é uma afirmação sobre a infraestrutura da Storeo"
      className="font-label-sm text-label-sm px-space-2xs py-space-3xs rounded bg-surface-variant text-outline uppercase tracking-wider"
    >
      {label}
    </span>
  );
}

/** Faixa no topo de uma tela/seção que é 100% mockup (sem backend nenhum). */
export function DemoBanner({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex items-center gap-space-xs rounded-xl bg-[#f59e0b]/10 border border-[#f59e0b]/25 px-space-md py-space-sm font-label-sm text-label-sm text-[#f59e0b]">
      <span className="material-symbols-outlined text-[16px] shrink-0">construction</span>
      <span>{children ?? 'Prévia do design — os números desta seção são ilustrativos, não refletem a infraestrutura real da Storeo.'}</span>
    </div>
  );
}
